
import React,{useState} from 'react';
import { Link as LinkScroll} from 'react-scroll';
import { Link as LinkPage, useLocation} from 'react-router-dom'
import {RiMenu3Line, RiCloseLine} from 'react-icons/ri';
import '../navbar/navbar.css';

 
 import {Logo2} from "../../components"
 

const NavApp = () => {

  
  const location = useLocation(); // Get current route

  const [navbar, setNavbar] = useState(false);
  const changeBackground = ()=>{

    if(window.scrollY >= 0.01){
      setNavbar(true)
    }
    else{
      setNavbar(false)
    }
  }
  window.addEventListener('scroll',changeBackground);


  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const renderNavLink = (to, label) => {
  
  if (location.pathname === '/') {
    return (
    
      <LinkScroll 
      className="nav-link nav-careers"  
       to={to}
        activeClass="active"
        spy={true}
       smooth={true}
       offset={0}
         duration={500}
        onClick={closeMobileMenu}
      >
        {label}
      </LinkScroll>
    );
  }
  
  return (
   
     <LinkPage
      className="nav-link nav-careers"  
        to={`/?scrollTo=${to}`}
       onClick={closeMobileMenu}
      >
        {label}
      </LinkPage>
  );
};

// For mobile navigation links
  const renderNavLinkMob = (to, label) => {
   
    if (location.pathname === '/') {
      return (
       
         <LinkScroll
                className='nav-links-new'
                 to={to}
               
               spy={true}
               smooth={true}
               offset={0}
               duration={500}
              onClick={closeMobileMenu}
              >
               {label}
              </LinkScroll>
      );
    }
    
    return (
   
       <LinkPage
         className='nav-links-new'
         to={`/?scrollTo=${to}`}
         onClick={() => {
         closeMobileMenu();
           }}
         >
         {label}
       </LinkPage>
    );
  };


  //only for BLOG link
   const renderPageNavLink = (path, section, linkText) => {
      if (location.pathname === path) {
        return (
         
           <LinkScroll 
           className="nav-link"  
            to={section}
            smooth={true}
            offset={0}
             duration={500}
           >
            {linkText}
            </LinkScroll>
        );
      }
      return (

         <LinkPage 
           className="nav-link"  
           to={{ pathname: path, state: { scrollTo: section } }}
           onClick={() => {
           localStorage.setItem('scrollTo', section);
            }}
           >
            {linkText}
            </LinkPage>
      );
    };
   //only for BLOG mob link
    const renderPageNavMobLink = (path, section, linkText) => {
      if (location.pathname === path) {
        return (

          <LinkScroll 
              className='nav-links-new' 
               to={section}
               smooth={true}
               offset={0}
               duration={500}
              onClick={closeMobileMenu}

              >
                {linkText}
              </LinkScroll> 
        );
      }
      return (

          <LinkPage 
              className='nav-links-new' 
              to={{ pathname: path, state: { scrollTo: section } }}
              onClick={() => {
              localStorage.setItem('scrollTo', section);
              closeMobileMenu();
               }}

              >
                {linkText}
              </LinkPage> 
      );
    };

    const renderContactLink = (to = "contact", label = "CONTACT") => {
  
  const knownRoutes = ['/', 
    '/careers', 
    '/blog', 
    '/blog/commoditizing-zero-knowledge-proofs', 
    '/blog/ponos-technology-s-hw-accelerated-plonky2-goldibear',
    '/blog/cryptocpu-validation-proving-made-fast-affordable-and-seamless',
    '/blog/scaling-stablecoins-with-confidentiality',
    '/blog/tech-deep-dive',
    '/blog/cryptocpu-making-zero-knowledge-proofs-fast-cost-disruptive-and-scalable',
    '/brand-assets']; 

  
  if (!knownRoutes.includes(location.pathname)) {
    return (
     
      <LinkPage 
      className="nav-link nav-contact"  
        to="/?scrollTo=contact"
      onClick={closeMobileMenu}
      > 
      {label}
      </LinkPage>

    );
  }

  return (
   
      <LinkScroll
      className="nav-link nav-contact"  
        to={to}
       activeClass="active"
       spy={true}
        smooth={true}
        offset={0}
       duration={500}
        onClick={closeMobileMenu}
      > 
      {label}
      </LinkScroll>
  );
};

   const renderContactMobLink = (to = "contact", label = "CONTACT") => {
  
  const knownRoutes = ['/', 
    '/careers', 
   '/blog', 
    '/blog/commoditizing-zero-knowledge-proofs', 
    '/blog/ponos-technology-s-hw-accelerated-plonky2-goldibear',
    '/blog/cryptocpu-validation-proving-made-fast-affordable-and-seamless',
    '/blog/scaling-stablecoins-with-confidentiality',
    '/blog/tech-deep-dive',
    '/blog/cryptocpu-making-zero-knowledge-proofs-fast-cost-disruptive-and-scalable',
    '/brand-assets']; 

  
  if (!knownRoutes.includes(location.pathname)) {
    return (
     
       <LinkPage
           className='nav-links-new'
           to="/?scrollTo=contact"
           onClick={closeMobileMenu}
              >
             {label}
         </LinkPage>
    );
  }

  return (

    <LinkScroll
           className='nav-links-new'
           to={to}
      
       spy={true}
       smooth={true}
       offset={0}
       duration={500}
        onClick={closeMobileMenu}
              >
             {label}
         </LinkScroll>
  );
};

            

  return (
   <header id="nav-bar" >
         <nav className={ navbar ? 
        'navbar navbar-expand-lg navbar-light active' : 'navbar navbar-expand-lg navbar-light'}>
    <div className="container-fluid">
    
     <Logo2 /> 
     <button  className="navbar-toggler">
     
     
        
         <div className='menu-icon-new' onClick={handleClick}>

            {click
          ? <RiCloseLine color="#212529" size={27} />
          : <RiMenu3Line color="#212529" size={27}  /> }

          </div>
            <ul className={click ? 'nav-menu-new active' : 'nav-menu-new'}>
              
            <li className='nav-item-new'>
              {/* <LinkScroll
                to='products'
                offset={-50}
                className='nav-links-new'
                onClick={closeMobileMenu}
              >
                PRODUCTS
              </LinkScroll> */}
               {renderNavLinkMob('productsNavApp', 'PRODUCTS')}
            </li>
            
            <li className='nav-item-new'>
              {/* <LinkScroll
                to='services'
                offset={-50}
                className='nav-links-new'
                onClick={closeMobileMenu}
              >
                SERVICES
              </LinkScroll> */}
               {renderNavLinkMob('servicesNavApp', 'SERVICES')}
            </li>
           
             <li className='nav-item-new'>
              {/* <LinkScroll to='projects' 
              offset={-65}
              className='nav-links-new' 
              onClick={closeMobileMenu}>
                PROJECTS
              </LinkScroll> */}
              {renderNavLinkMob('projectsNavApp', 'PROJECTS')}
            </li>
            
             <li className='nav-item-new'>
              {/* <LinkScroll
                to='about'
                offset={-75}
                className='nav-links-new'
                onClick={closeMobileMenu}
              >
                ABOUT
              </LinkScroll> */}
              {renderNavLinkMob('aboutNavApp', 'ABOUT')}
            </li>
              <li className='nav-item-new'>
              {/* <LinkScroll to='blog' 
              offset={-65}
              className='nav-links-new' 
              onClick={closeMobileMenu}>
                BLOG
              </LinkScroll> */}
               {renderPageNavMobLink('/blog', 'blog-NavApp', 'BLOG')}
            </li>
             <li className='nav-item-new'>
              {/* <LinkScroll
                to='careers'
                offset={-50}
                className='nav-links-new'
                onClick={closeMobileMenu}
              >
                CAREERS
              </LinkScroll> */}
              {renderNavLinkMob('careersNavApp', 'CAREERS')}
            </li> 
             <li className='nav-item-new'>
              {/* <LinkScroll
                to='contact'
                offset={-55}
                className='nav-links-new'
                onClick={closeMobileMenu}
              >
                CONTACT
              </LinkScroll> */}
              {renderContactMobLink()}
            </li>
          </ul>
          
      
    </button> 

    <div className= "collapse navbar-collapse" id="navbarNav">
       
      <ul className= "navbar-nav ms-auto">
       
        <li className="nav-item">
          {/* <LinkScroll className="nav-link"  to="products" offset={-45}  >PRODUCTS</LinkScroll> */}
              {renderNavLink('productsNavApp', 'PRODUCTS')}
        </li>
        
        <li className="nav-item">
          {/* <LinkScroll className="nav-link"  to="services" offset={-45}  >SERVICES</LinkScroll> */}
           {renderNavLink('servicesNavApp', 'SERVICES')}
         
        </li>
       
         <li className="nav-item">
          {/* <LinkScroll className="nav-link"  to="projects" offset={-65} >PROJECTS</LinkScroll> */}
           {renderNavLink('projectsNavApp', 'PROJECTS')}
        </li>
       
        <li className="nav-item">
          {/* <LinkScroll className="nav-link "  to="about" offset={-60}>ABOUT</LinkScroll> */}
          {renderNavLink('aboutNavApp', 'ABOUT')}
        </li>
          <li className="nav-item">
          {/* <LinkScroll className="nav-link"  to="blog" offset={-65} >BLOG</LinkScroll> */}
          {renderPageNavLink('/blog', 'blog-NavApp', 'BLOG')}
        </li>
         <li className="nav-item">
          {/* <LinkScroll className="nav-link nav-careers"  to="careers" offset={-48} >CAREERS</LinkScroll> */}
           {renderNavLink('careersNavApp', 'CAREERS')}
        </li> 
        <li className="nav-item">
          {/* <LinkScroll className="nav-link nav-contact"  to="contact" offset={-58}> CONTACT</LinkScroll> */}
          {renderContactLink()}
        </li>
        
      </ul>
     
    </div>
  </div>
</nav>

        </header>
  )
}

export default NavApp
